/**
 * Chip del estado de una plantilla. El texto y el color salen de `ESTADO_PLANTILLA`, que es
 * exhaustivo: un estado nuevo sin texto rompe tsc. Si igual llegara uno desconocido en runtime
 * (backend más nuevo), se muestra el código crudo en gris: nunca otro estado.
 *
 * Con `modo` y `simulado`, una aprobada en simulado con el servidor en twilio dice «Aprobada en
 * simulado» en ámbar (`estadoPlantillaVisible`): Meta nunca la aprobó. Sin `modo`, lo de siempre.
 *
 * Sin mayúsculas: el estado de una plantilla es una frase («Falta mandarla a aprobar», «Aprobada en simulado») y en
 * mayúsculas se leía como un grito («NO LLEGÓ A META»).
 */

import type { EstadoPlantilla } from "../types";
import { ESTADO_PLANTILLA, estadoPlantillaVisible } from "../logic/textos";

export function ChipEstadoPlantilla({ estado, className = "", simulado, modo }: {
  estado: EstadoPlantilla; className?: string; simulado?: boolean; modo?: string | null;
}) {
  const info = ESTADO_PLANTILLA[estado] ? estadoPlantillaVisible({ estado, simulado }, modo) : { label: String(estado || "sin estado"), cls: "bg-slate-100 text-slate-500", ayuda: "" };
  return (
    <span title={info.ayuda || undefined} className={`text-[11px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${info.cls} ${className}`}>
      {info.label}
    </span>
  );
}

export default ChipEstadoPlantilla;
